import React from "react"

export default function Card({ className, children }) {
  return (
    <div className={className}>
      <div className="flex flex-col justify-center h-full">{children}</div>
    </div>
  )
}
